import { useTranslation } from "react-i18next";

type ListItem =
  | {
      key: string;
      variables?: Record<string, string>;
    }
  | string;

interface RenderListProps {
  items: ListItem[];
}

export const RenderList = ({ items }: RenderListProps) => {
  const { t } = useTranslation();

  return (
    <ul className="list-disc pl-2">
      {items.map((item) => {
        if (typeof item === "string") {
          return <li key={item}>{t(item)}</li>;
        }
        const { key, variables = {} } = item;
        return <li key={key}>{t(key, variables)}</li>;
      })}
    </ul>
  );
};
